document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const productRoot = form.closest('[data-product-root]');
    const id = form.querySelector('[name="id"]');
    const price = productRoot?.querySelector('[data-product-price]');
    const submit = form.querySelector('[type="submit"]');
    const variants = JSON.parse(form.querySelector('[data-variants-json]').textContent);
    const options = [...form.querySelectorAll('[data-option-select]')];
    const optionButtons = [...form.querySelectorAll('[data-option-button]')];
    const technicalPanels = [...(productRoot?.querySelectorAll('[data-finish-panel]') || [])];
    const productPreviews = [...(productRoot?.querySelectorAll('[data-product-preview]') || [])];
    const galleryMain = productRoot?.querySelector('[data-gallery-main]');
    const lightboxPreview = productRoot?.querySelector('[data-gallery-lightbox-preview]');
    const sceneButtons = [...(productRoot?.querySelectorAll('[data-gallery-scene]') || [])];
    const previewSize = productRoot?.querySelector('[data-preview-size]');
    const preparedPreview = galleryMain?.classList.contains('product-preview--prepared');
    const finishIndex = options.length > 1 ? 1 : -1;
    const colorIndex = options.length > 2 ? 2 : -1;
    const assetProbe = productRoot?.querySelector('[data-prepared-asset-probe]');
    const probeValue = assetProbe ? getComputedStyle(assetProbe).backgroundImage : '';
    const probeUrl = probeValue.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
    const assetBase = probeUrl ? probeUrl.slice(0, probeUrl.lastIndexOf('/') + 1) : '';
    const preparedAssetVersion = '20260903-2026-scenes';

    const setPreparedImage = (preview) => {
      if (!preparedPreview || !preview || !assetBase) return;
      const handle = preview.dataset.preparedHandle;
      const scene = preview.dataset.scene;
      let filename = `${handle}-gallery-${scene}.webp`;
      if (scene === 'variant') {
        const finish = preview.dataset.previewFinish;
        const color = finish === 'poster' ? 'sans-cadre' : preview.dataset.previewColor;
        filename = `${handle}-variant-${preview.dataset.previewFormat}-${finish}-${color}.webp`;
      }
      const wall = preview.querySelector('.product-preview__wall');
      if (wall) wall.style.backgroundImage = `url("${assetBase}${filename}?v=${preparedAssetVersion}")`;
    };

    const setPreparedThumbnails = () => {
      if (!preparedPreview || !assetBase) return;
      const handle = galleryMain.dataset.preparedHandle;
      sceneButtons.forEach((button) => {
        const scene = button.dataset.galleryScene;
        const filename = scene === 'variant'
          ? `${handle}-variant-30x40-standard-noir.webp`
          : `${handle}-gallery-${scene}.webp`;
        const image = button.querySelector('.product-scene-thumb__image');
        if (image) image.style.backgroundImage = `url("${assetBase}${filename}?v=${preparedAssetVersion}")`;
      });
    };

    const update = () => {
      const values = options.map((select) => select.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === values[index]));

      optionButtons.forEach((button) => {
        const buttonIndex = Number(button.dataset.optionIndex);
        const selected = values[buttonIndex] === button.dataset.optionValue;
        const candidateValues = [...values];
        candidateValues[buttonIndex] = button.dataset.optionValue;
        if (buttonIndex === finishIndex && colorIndex >= 0) {
          if (button.dataset.optionValue === options[finishIndex].options[0].value) candidateValues[colorIndex] = options[colorIndex].options[0].value;
          if (button.dataset.optionValue !== options[finishIndex].options[0].value && candidateValues[colorIndex] === options[colorIndex].options[0].value) candidateValues[colorIndex] = options[colorIndex].options[1].value;
        }
        if (buttonIndex === colorIndex && finishIndex >= 0) {
          if (button.dataset.optionValue === options[colorIndex].options[0].value) candidateValues[finishIndex] = options[finishIndex].options[0].value;
          if (button.dataset.optionValue !== options[colorIndex].options[0].value && candidateValues[finishIndex] === options[finishIndex].options[0].value) candidateValues[finishIndex] = options[finishIndex].options[1].value;
        }
        const exists = variants.some((item) => item.options.every((value, index) => value === candidateValues[index]));
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
        button.disabled = !exists;
      });

      const selectedFinish = finishIndex >= 0 ? values[finishIndex].toLowerCase() : '';
      const technicalKey = selectedFinish.includes('premium')
        ? 'premium'
        : selectedFinish.includes('standard')
          ? 'standard'
          : 'poster';
      technicalPanels.forEach((panel) => {
        panel.hidden = panel.dataset.finishPanel !== technicalKey;
      });
      const selectedFormat = (values[0] || '').toLowerCase();
      const previewFormat = selectedFormat.includes('50')
        ? '50x70'
        : selectedFormat.includes('30')
          ? '30x40'
          : 'a4';
      const selectedColor = colorIndex >= 0 ? values[colorIndex].toLowerCase() : 'sans-cadre';
      const previewColor = selectedColor.includes('naturel') || selectedColor.includes('natural')
        ? 'naturel'
        : selectedColor.includes('blanc') || selectedColor.includes('white')
          ? 'blanc'
          : selectedColor.includes('noir') || selectedColor.includes('black')
            ? 'noir'
            : 'sans-cadre';
      productPreviews.forEach((preview) => {
        preview.dataset.previewFinish = technicalKey;
        preview.dataset.previewColor = previewColor;
        preview.dataset.previewFormat = previewFormat;
        if (preparedPreview) preview.dataset.scene = 'variant';
        setPreparedImage(preview);
      });
      if (preparedPreview) {
        sceneButtons.forEach((button) => {
          const selected = button.dataset.galleryScene === 'variant';
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
      }
      if (previewSize) previewSize.textContent = values[0] || '';
      setPreparedThumbnails();

      if (variant) {
        id.value = variant.id;
        if (price) price.textContent = variant.price_formatted;
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? submit.dataset.availableText : submit.dataset.soldText;
        try {
          history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
        } catch (error) {
          // Certains aperçus Shopify sont intégrés dans une iframe qui bloque cette mise à jour.
        }
      } else {
        submit.disabled = true;
        submit.textContent = submit.dataset.soldText;
      }
    };

    optionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const index = Number(button.dataset.optionIndex);
        const select = options[index];
        if (!select) return;
        select.value = button.dataset.optionValue;
        if (index === finishIndex && colorIndex >= 0) {
          if (select.selectedIndex === 0) options[colorIndex].selectedIndex = 0;
          if (select.selectedIndex !== 0 && options[colorIndex].selectedIndex === 0) options[colorIndex].selectedIndex = 1;
        }
        if (index === colorIndex && finishIndex >= 0) {
          if (select.selectedIndex === 0) options[finishIndex].selectedIndex = 0;
          if (select.selectedIndex !== 0 && options[finishIndex].selectedIndex === 0) options[finishIndex].selectedIndex = 1;
        }
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    options.forEach((select) => select.addEventListener('change', update));
    update();

    sceneButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (galleryMain) galleryMain.dataset.scene = button.dataset.galleryScene;
        setPreparedImage(galleryMain);
        sceneButtons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
      });
    });

    const lightbox = productRoot?.querySelector('[data-product-lightbox]');
    const openLightbox = productRoot?.querySelector('[data-open-product-zoom]');
    const closeLightbox = productRoot?.querySelector('[data-close-product-zoom]');
    openLightbox?.addEventListener('click', () => {
      if (lightboxPreview && galleryMain) {
        lightboxPreview.dataset.scene = galleryMain.dataset.scene;
        setPreparedImage(lightboxPreview);
      }
      lightbox?.showModal();
    });
    closeLightbox?.addEventListener('click', () => lightbox?.close());
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });
  });

  document.querySelectorAll('[data-sticky-submit]').forEach((button) => {
    button.addEventListener('click', () => document.querySelector('[data-product-form] [type="submit"]')?.click());
  });

  document.querySelectorAll('[data-bundle-button]').forEach((button) => {
    button.addEventListener('click', async () => {
      const ids = button.dataset.variantIds.split(',').filter(Boolean);
      if (!ids.length) return;
      button.disabled = true;
      const original = button.textContent;
      button.textContent = button.dataset.loading;
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: ids.map((variantId) => ({ id: Number(variantId), quantity: 1, properties: { _composition: button.dataset.setName } })) }),
        });
        if (!response.ok) throw new Error('cart');
        window.location.href = `${window.Shopify.routes.root}cart`;
      } catch (error) {
        button.textContent = button.dataset.error;
        setTimeout(() => {
          button.textContent = original;
          button.disabled = false;
        }, 2500);
      }
    });
  });
});
